'use client'

/* eslint-disable import/namespace */
import Icon from '@doist/icons/brand'
import { Button } from '@doist/marketist'

import { SignupButton } from './button-signup'

import type { ButtonProps } from '../types'

function CPButton(props: ButtonProps) {
    const { url, size, variant, buttonText, endIcon, startIcon, type = 'custom' } = props.fields
    const endIconName = endIcon?.fields.iconName
    const startIconName = startIcon?.fields.iconName

    return (
        <>
            {type === 'signup' ? <SignupButton /> : null}

            {type === 'custom' ? (
                <Button
                    href={url}
                    size={size}
                    variant={variant}
                    // pass icon the icon name to the icon function
                    {...(endIconName ? { endIcon: () => <Icon name={endIconName} /> } : {})}
                    {...(startIconName ? { startIcon: () => <Icon name={startIconName} /> } : {})}
                    {...(variant === 'tertiary' ? { bleed: true } : {})}
                >
                    {buttonText}
                </Button>
            ) : null}
        </>
    )
}

export { CPButton }
